import { render, staticRenderFns } from "./gooddetail.vue?vue&type=template&id=6d23044a&scoped=true&"
import script from "./gooddetail.vue?vue&type=script&lang=js&"
export * from "./gooddetail.vue?vue&type=script&lang=js&"
import style0 from "./gooddetail.vue?vue&type=style&index=0&id=6d23044a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23044a",
  null
  
)

export default component.exports